import {
  DeploymentEnv,
  Site,
  findDeploymentEnvFromUrl,
  findLocaleFromUrlAndCookie,
  findSiteByDomain,
  findSiteFromUrl,
  getLanguageFromLocale,
} from '@zooplus/commons-lang';

import { DEFAULT_DOMAIN, DEFAULT_LOCALE } from '@utilities/constants';
import { addScript, getDeviceType, getMktExternalUrl } from '@utilities/utils';

const EXTERNAL_SCRIPT_LOADER = 'ext-checkout-spa';

export type AppConfigContextProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  site: Site;
  environment: DeploymentEnv;
  deviceType: 'WEB' | 'IOS' | 'ANDROID';
};

let appConfig: AppConfigContextProps;

const getAppConfig = () => {
  if (!appConfig) {
    initialiseAppConfig();
  }
  return appConfig;
};

const initialiseAppConfig = () => {
  const site = findSiteFromUrl() || findSiteByDomain(DEFAULT_DOMAIN);
  const locale = findLocaleFromUrlAndCookie() || DEFAULT_LOCALE;
  const language = getLanguageFromLocale(locale) || site.language;

  appConfig = {
    site: {
      ...site,
      locale,
      language,
    },
    environment: findDeploymentEnvFromUrl(),
    deviceType: getDeviceType(),
  };

  const externalScriptLoaderUrl = `${getMktExternalUrl(
    appConfig.environment,
  )}/script-loader/main.js`;
  addScript(externalScriptLoaderUrl, EXTERNAL_SCRIPT_LOADER, true, false);
};

export { getAppConfig };
